export const environment = {
  name: "eplostar-test",
  email: "ariannace@gmail.com",
  phone: "+39 340 504 1973",
  userPoolId: "us-east-1_ScbUK7OPT",
  userPoolWebClientId: "7r005mri0qi49m4sgia6hk163q",
  stripePublishableKey: "pk_test_51LzFC1BoYNzBgZzRNiX5pZG6hTTvarj8DqlbYCj35WyDIXYKLEuZGVap27DcHQ88lCy1GSh5CfTK8mqnV8wYcdxG00UnSSh80K",
  region: "us-east-1",
  webSocketApiId: "vvf7yeqlri",
  apiKey: "cbc89713-6d86-12cb-a18b-37f9d33c0fed",
  baseUrl: "https://www2.eplostar.com",
  baseUrlImager: "https://img2.eplostar.com"
};
